module.exports = global["firebase"] = require("-!./index.cjs.js");